class A_And_B {
    static path = 'logic/and';

    constructor(mutator){
        this.addInput("Condition A", "boolean");
        this.addInput("Condition B", "boolean");
        this.addOutput("true/false", "boolean");
        this.bgcolor = '#70d3ef';
        this.title = 'If A and B ...';
        this.desc = 'Conditional Branch';
    }
}

module.exports = A_And_B
